import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ICreateOrUpdateExternalTokenPayload,
  IDeleteExternalTokenPayload,
  IFetchExternalTokensPayload,
} from './types'

const getConfig = (): AxiosRequestConfig => ({
  responseType: 'json'
})

export function fetchExternalTokens(payload: IFetchExternalTokensPayload) {
  return axios.get(`/api/v1/subtitles/${payload.subtitleId}/external_tokens`, getConfig())
}

export function createOrUpdateExternalToken(payload: ICreateOrUpdateExternalTokenPayload) {
  return axios.post(`/api/v1/subtitles/${payload.subtitleId}/external_tokens`, convertToSnakeCase(payload), getConfig())
}

export function deleteExternalToken(payload: IDeleteExternalTokenPayload) {
  return axios.delete(`/api/v1/subtitles/${payload.subtitleId}/external_tokens/${payload.externalTokenId}`, getConfig())
}
